export enum Mode {
  TryIt = 'TRYIT',
  Complete = 'COMPLETE'
}

export enum LoginType {
  Redirect = 'REDIRECT',
  Popup = 'POPUP'
}

export enum ContentType {
  XML = 'application/xml',
  Json = 'application/json',
  Image = 'image/jpeg',
  TextPlain = 'text/plain',
  HTML = 'text/html',
  BinaryResponse = 'application/octet-stream',
  TextCsv = 'text/csv',
}

export enum AppTheme {
  Dark = 'dark',
  HighContrast = 'high-contrast',
  Light = 'light',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}
